import Aside from "./Aside";
import "../../../css/apply.css";
import { useContext, useEffect } from "react";
import UserContext from "../../../services/Context/UserContext";
import API from "../../../services/API";
import JWT from "../../../services/JWT";
import MobileFooter from "./MobileFooter";
import MobileHeader from "./MobileHeader";
import MobileLogo from "./MobileLogo";

export default function Layout({ children, center }){

    const { user, setUser } = useContext(UserContext)

    useEffect(() => {

        if( !user && JWT.hasRefreshToken() ){

            API.get('/refresh', { headers: { Authorization: 'Bearer ' + JWT.getRefreshToken() } })
                .then(r => {

                    JWT.setTokens(r.data)

                    setUser(r.data)
                })

        }

    }, [user, setUser])
    

    return (
        <main className="apply-layout">

            <MobileLogo />
            
            <Aside />

            <section className={`apply-section${center ?  '-center' : ''}`}>

                <MobileHeader />

                {children}

            </section>

            <MobileFooter />
            
        </main>
    );
}